// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { Table } from "flowbite-react";


// function AGroupBoxingQuantity({ orderid, transformedData }) {
//     const [resultQuantities, setResultQuantities] = useState([]); 
//     const [totalPieces, setTotalPieces] = useState(0);
//     const url = localStorage.getItem("url");

//     useEffect(() => {
//         if (orderid) {
//             fetchAvailableQuantity();
//         }
//     }, [orderid, transformedData]);

//     const fetchAvailableQuantity = async () => {
//         try {
//             const response = await axios.post(`/group_boxing/get_available_quantity/${orderid}`, transformedData); // Use POST here
//             const result = response.data;

//             if (result.success === 2) {
//                 setResultQuantities(result.result_quantities); 
//                 const total = result.result_quantities.reduce((acc, item) => acc + (item.totalpiece || 0), 0);
//                 setTotalPieces(total);
//             } else {
//                 console.error(result.message);
//             }
//         } catch (error) {
//             console.error("Error fetching available quantity:", error);
//         }
//     };

//     return (
//         <div className="overflow-x-auto p-2">
//             <Table hoverable>
//                 <Table.Head>
//                     <Table.HeadCell>Color</Table.HeadCell>
//                     <Table.HeadCell>Missing Size Variant</Table.HeadCell>
//                     <Table.HeadCell>Remaining Size Variant</Table.HeadCell>
//                     <Table.HeadCell>Total</Table.HeadCell>
//                 </Table.Head>
//                 <Table.Body className="divide-y">
//                     {resultQuantities.map((item, index) => {
//                         return (
//                             <Table.Row key={index} className="bg-white">
//                                 <Table.Cell className="font-semibold">
//                                     <div className="flex items-center space-x-2">
//                                         <div className="flex items-center justify-center">
//                                             <img
//                                                 src={`${url}${item.colour_image}`}
//                                                 alt={item.color}
//                                                 className="w-[25px] h-[25px] object-cover rounded-lg drop-shadow-md"
//                                             />
//                                         </div>
//                                         <span>{item.color}</span>
//                                     </div>
//                                 </Table.Cell>
//                                 <Table.Cell>{item["missing sizevariant"]}</Table.Cell> {/* Display Missing Size Variant */}
//                                 <Table.Cell>{item["remainingsizevariet"]}</Table.Cell> {/* Display Remaining Size Variant */}
//                                 <Table.Cell>{item.totalpiece}</Table.Cell>
//                             </Table.Row>
//                         );
//                     })}
//                     <Table.Row className="bg-gray-100 font-bold">
//                         <Table.Cell colSpan="3" className="text-right">Grand Total:</Table.Cell>
//                         <Table.Cell>{totalPieces}</Table.Cell>
//                     </Table.Row>
//                 </Table.Body>
//             </Table>
//         </div>
//     );
// }

// export default AGroupBoxingQuantity;

import { Table } from "flowbite-react";
import { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";

const AvailableQuantityTable = ({ orderid, transformedData }) => {
    const [resultQuantities, setResultQuantities] = useState([]);
    const [sizeVariants, setSizeVariants] = useState([]);
    const [totalPieces, setTotalPieces] = useState(0);
    const url = localStorage.getItem("url");
    useEffect(() => {
        if (orderid) {
            fetchAvailableQuantity();
        }
    }, [orderid, transformedData]);

    const fetchAvailableQuantity = async () => {
        try {
            const response = await axios.post(`/group_boxing/get_available_quantity/${orderid}`, transformedData);
            const result = response.data;

            if (result.success === 2) {
                setResultQuantities(result.result_quantities.result_quantities || []);
                setSizeVariants(result.result_quantities.size_variants || []);

                const total = (result.result_quantities.result_quantities || []).reduce(
                    (acc, item) => acc + (item.totalpiece || 0),
                    0
                );
                setTotalPieces(total);
            }
            else if (result.success === 4) {
                Swal.fire({
                    icon: "error",
                    text: result.msg,
                    type: "error",
                    timer: 2000,
                    showConfirmButton: false,
                });
            }
            else {
                console.error(result.message);
            }
        } catch (error) {
            console.error("Error fetching available quantity:", error);
        }
    };

    return (
        <div className="overflow-x-auto p-2">
            {/* <Table hoverable>
                <Table.Head>
                    <Table.HeadCell>Color</Table.HeadCell>
                    {sizeVariants.map((size) => (
                        <Table.HeadCell key={size}>{size}</Table.HeadCell>
                    ))}
                    <Table.HeadCell>Total</Table.HeadCell>
                </Table.Head>

                <Table.Body className="divide-y">
                    {resultQuantities.map((item, index) => (
                        <Table.Row key={index} className="bg-white dark:border-gray-700 dark:bg-gray-800">
                            <Table.Cell>
                                <div className="flex items-center space-x-2">
                                    <div className="flex items-center justify-center">                                             <img
                                        src={`${url}${item.colour_image}`}
                                        alt={item.color}
                                        className="w-[25px] h-[25px] object-cover rounded-lg drop-shadow-md"
                                    />
                                    </div>
                                    <span>{item.color}</span>
                                </div>
                            </Table.Cell>

                            {sizeVariants.map((size) => (
                                <Table.Cell key={size}>
                                    <b>{item.missing_sizevariant[size] || 0}</b> (
                                    {item.remaining_sizevariant[size] || 0})
                                </Table.Cell>
                            ))}

                            <Table.Cell>{item.totalpiece || 0}</Table.Cell>
                        </Table.Row>
                    ))}
                </Table.Body>
            </Table> */}

            <Table hoverable className="text-sm border">
                <Table.Head className="text-xs border">
                    <Table.HeadCell className="py-1 border">Color</Table.HeadCell>
                    {sizeVariants.map((size) => (
                        <Table.HeadCell key={size} className="py-1 border">{size}</Table.HeadCell>
                    ))}
                    <Table.HeadCell className="py-1 border">Total</Table.HeadCell>
                </Table.Head>

                <Table.Body className="divide-y border">
                    {resultQuantities.map((item, index) => (
                        <Table.Row key={index} className="border bg-white dark:border-gray-700 dark:bg-gray-800">
                            <Table.Cell className="py-1 border">
                                

                                <div className="w-[60px] mx-auto ">
                                    <img
                                          src={`${url}${item.colour_image}`}
                                          alt={item.color}
                                        className="w-[20px] h-[20px] object-cover rounded-lg drop-shadow-md mb-1 mx-auto"
                                    />
                                    <div className="text-[10px] text-jutify break-words whitespace-normal leading-tight ">
                                    {item.color}
                                    </div>
                                </div>
                            </Table.Cell>

                            {sizeVariants.map((size) => (
                                <Table.Cell key={size} className="py-1 border">
                                    <b>{item.missing_sizevariant[size] || 0}</b> (
                                    {item.remaining_sizevariant[size] || 0})
                                </Table.Cell>
                            ))}

                            <Table.Cell className="py-1">{item.totalpiece || 0}</Table.Cell>
                        </Table.Row>
                    ))}
                </Table.Body>
            </Table>

            {/* <div className="mt-4 font-bold">
                Grand Total Pieces: {totalPieces}
            </div> */}
        </div>
    );
};

export default AvailableQuantityTable;
